import { render, staticRenderFns } from "./shunfengPrint.vue?vue&type=template&id=20811d8f&scoped=true&"
import script from "./shunfengPrint.vue?vue&type=script&lang=ts&"
export * from "./shunfengPrint.vue?vue&type=script&lang=ts&"
import style0 from "./shunfengPrint.vue?vue&type=style&index=0&id=20811d8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20811d8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
